import React from 'react'

const TeamDayOffManagementSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_700_37871)" />
    <path
      d="M20.5771 47.4136C20.5771 49.1348 21.9423 50.4999 23.6635 50.4999H46.3361C48.0574 50.4999 49.4225 49.1348 49.4225 47.4136V29.8452H20.5771V47.4136ZM34.9998 34.8308C36.4243 34.8308 37.552 35.9585 37.552 37.3236C37.552 38.6887 36.3649 39.8758 34.9998 39.8758C33.6347 39.8758 32.4477 38.6887 32.4477 37.3236C32.4477 35.8992 33.5754 34.8308 34.9998 34.8308ZM30.311 44.802C30.7264 42.606 32.5664 40.9441 34.7624 40.8848C37.0772 40.8254 39.1545 42.3092 39.6293 44.5053C39.8667 45.3956 39.6293 45.6923 38.739 45.6923C37.4926 45.6923 36.2462 45.6923 34.9998 45.6923C33.6941 45.6923 32.3883 45.6923 31.0825 45.6923C30.3703 45.6923 30.1923 45.3956 30.311 44.802Z"
      fill="white"
    />
    <path
      d="M46.3361 21.5953H43.2498V19.5773C43.2498 18.4496 42.3002 17.5 41.1725 17.5C40.0448 17.5 39.0951 18.4496 39.0951 19.5773V21.6547H30.9045V19.5773C30.9045 18.4496 29.9548 17.5 28.8271 17.5C27.6995 17.5 26.7498 18.4496 26.7498 19.5773V21.6547H23.6635C21.9423 21.5953 20.5771 23.0198 20.5771 24.741V27.8273H49.4225V24.741C49.4225 23.0198 48.0574 21.5953 46.3361 21.5953Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_700_37871"
        x1="34.5455"
        y1="0"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49912D" />
        <stop offset="1" stopColor="#33691E" />
      </linearGradient>
    </defs>
  </svg>
)

export default TeamDayOffManagementSubcategory
